import { Main } from "../../../Main";
import { Building, WallSide } from "../../../building/Building";
import { LeanToConfig } from "../../../config/LeanToConfig";
import { LeanTo } from "./LeanTo";
import { ISceneAddon } from "../../addon/ISceneAddon";

export class LeanToManager
{
	private _building : Building;

	private _front : LeanTo;
	private _back  : LeanTo;
	private _left  : LeanTo;
	private _right : LeanTo;

	private _config:LeanToConfig;

	constructor(building:Building)
	{
		this._building = building;
		this._config = Main.getInstance().config.building.leanto;

		this._front = new LeanTo(Building.WALLS.FRONT, this._config.front, building);
		this._back  = new LeanTo(Building.WALLS.BACK,  this._config.back,  building);
		this._left  = new LeanTo(Building.WALLS.LEFT,  this._config.left,  building);
		this._right = new LeanTo(Building.WALLS.RIGHT, this._config.right, building);
	}

	public getLeanTo(wall: WallSide): LeanTo
	{
		return this[`_${wall}`];
	}

	public addListeners()
	{
		const walls: WallSide[] = ["front", "back", "left", "right"];
		for (const wall of walls)
		{
			this[`_${wall}`].addListeners();
		}
	}

	public removeListeners()
	{
		const walls: WallSide[] = ["front", "back", "left", "right"];
		for (const wall of walls)
		{
			this[`_${wall}`].removeListeners();
		}
	}

	public isThereAConflictWithAddons = (walls: string[]): boolean =>
	{
		for (const wall of walls)
		{
			if (this[`_${wall}`].isThereAConflictWithAddons())
			{
				return true;
			}
		}

		return false;
	};

	public isThereAConflictWithAddon = (wall: string, addon: ISceneAddon): boolean =>
	{
		return this[`_${wall}`].isThereAConflictWithAddon(addon);
	};
}